import React from 'react'
import Sidebar from './Sidebar'

interface AppShellProps {
    isDesktop: boolean
    showSidebar?: boolean
    isAuth?: boolean
    pageClassName?: string
    children: React.ReactNode
}

const AppShell = ({ isDesktop, showSidebar, isAuth, pageClassName, children }: AppShellProps): JSX.Element => {
    return (
        <div className={`app-shell
      ${isDesktop ? 'app-shell--desktop' : 'app-shell--mobile'}
      ${showSidebar ? 'app-shell--with-sidebar' : ''}
      ${isAuth ? 'app-shell--auth' : ''}
      ${pageClassName ?? ''}
    `}>
            <div className="app-shell__container">
                {isDesktop && showSidebar ? (
                    <div className="app-shell__sidebar ">
                        <Sidebar />
                    </div>
                ) : null}
                <div className="app-shell__content">
                    <div className="app-container card">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AppShell
